export enum Experiment {
  EnableCSSOptimization = 'specs.myAccount.EnableCSSOptimization',
  EnablePhoneNumberValidation = 'specs.myAccount.EnablePhoneNumberValidation',
}
